// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/event/:eventId\",\"regex\":\"^/event/([^/]+)$\",\"paramNames\":[\"eventId\"],\"hasOptionalPrefix\":false},{\"path\":\"/chat/:conversationId\",\"regex\":\"^/chat/([^/]+)$\",\"paramNames\":[\"conversationId\"],\"hasOptionalPrefix\":false},{\"path\":\"/companies/:slug\",\"regex\":\"^/companies/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/companies/preview/:companyId\",\"regex\":\"^/companies/preview/([^/]+)$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/sessionStudentLogin/:sessionId\",\"regex\":\"^/sessionStudentLogin/([^/]+)$\",\"paramNames\":[\"sessionId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/activate-parent/confirmed\"},{\"path\":\"/login\"},{\"path\":\"/register\"},{\"path\":\"/register/global-instant\"},{\"path\":\"/verify/confirmed\"},{\"path\":\"/about\"},{\"path\":\"/auth\"},{\"path\":\"/auth/registration-info\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/auth/verify\"},{\"path\":\"/chat\"},{\"path\":\"/companies\"},{\"path\":\"/dashboard\"},{\"path\":\"/global-instant\"},{\"path\":\"/professions\"},{\"path\":\"/sessionStudentLogin\"},{\"path\":\"/teacher-instant\"},{\"path\":\"/user\"},{\"path\":\"/imprint\"},{\"path\":\"/privacy\"},{\"path\":\"/terms\"},{\"path\":\"/403\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/monterro";import * as Sentry from '@sentry/nextjs'
import { clientConfig } from './config/client.config'

if (clientConfig.sentry.enabled) {
    Sentry.init({
        dsn: clientConfig.sentry.enabled ? clientConfig.sentry.dsn : '',
        enabled: clientConfig.sentry.enabled,

        // Enable logs to be sent to Sentry
        enableLogs: clientConfig.sentry.enabled,

        // Add optional integrations for additional features
        integrations: [
            Sentry.replayIntegration({
                // Additional Replay configuration goes in here, for example:
                maskAllText: true,
                blockAllMedia: true,
            }),
            // Spotlight connects to localhost:8969 - only enable in development
            ...(process.env.NODE_ENV === 'development' ? [Sentry.spotlightBrowserIntegration()] : []),
            Sentry.captureConsoleIntegration({
                levels: ['log', 'info', 'warn', 'error', 'debug'],
            }),
        ],

        // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
        tracesSampleRate: clientConfig.sentry.enabled ? Number(clientConfig.sentry.tracesSampleRate) : 0,

        // Define how likely Replay events are sampled.
        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: clientConfig.sentry.enabled
            ? Number(clientConfig.sentry.replaysSessionSampleRate)
            : 0,

        // Define how likely Replay events are sampled when an error occurs.
        replaysOnErrorSampleRate: clientConfig.sentry.enabled
            ? Number(clientConfig.sentry.replaysOnErrorSampleRate)
            : 0,

        // Setting this option to true will print useful information to the console while you're setting up Sentry.
        debug: clientConfig.sentry.debug,

        environment: clientConfig.sentry.environment,

        // Enable sending user PII (Personally Identifiable Information)
        // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
        sendDefaultPii: false,
    })
} else {
    console.log('Sentry client initialization skipped')
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
